import { type FutureSpanPayment, type ReservationPaymentLocationState } from '@features/reservation/types';

const isFutureSpanPayment = (value: unknown): value is FutureSpanPayment => {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<FutureSpanPayment>;
  return (
    typeof candidate.reservationId === 'string' &&
    typeof candidate.reservationSpanId === 'string' &&
    typeof candidate.price?.amount === 'number' &&
    typeof candidate.price?.currency === 'string'
  );
};

/**
 * Read the future span being paid for from `/reservation/payment`'s router state. `undefined` means the page
 * pays for something else. The state survives a reload (history state), but not a copied URL.
 */
export function readFutureSpanPayment(locationState: unknown): FutureSpanPayment | undefined {
  if (!locationState || typeof locationState !== 'object') return undefined;
  const { futureSpanPayment } = locationState as ReservationPaymentLocationState;
  return isFutureSpanPayment(futureSpanPayment) ? futureSpanPayment : undefined;
}
